import { render, staticRenderFns } from "./ActivityTabCalendar2.vue?vue&type=template&id=58d2d1f4&scoped=true&"
import script from "./ActivityTabCalendar2.vue?vue&type=script&lang=js&"
export * from "./ActivityTabCalendar2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d2d1f4",
  null
  
)

export default component.exports